@if (!selectedItem || !showSelectionDiv) {
  <div class="search-field-container" #searchContainer>
    <!-- Search Input Wrapper -->
    <div class="search-input-wrapper" [class.focused]="isFocused" [class.has-value]="searchCtrl.value">
      <!-- Search Icon -->
      <span class="search-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.3-4.3"></path>
        </svg>
      </span>
      <!-- Input Field -->
      <input
        #searchInput
        type="text"
        class="search-input"
        [placeholder]="searchPlaceHolder"
        [formControl]="searchCtrl"
        (focus)="onFocusSelectionInput(); isFocused = true"
        (blur)="onBlurSelectionInput(); isFocused = false"
        (keydown)="onKeyDown($event)"
        (keydown.enter)="$event.preventDefault(); selectHighlightedItem()"
        autocomplete="off">
      <!-- Loading Spinner -->
      @if (isLoading) {
        <span class="search-loading">
          <span class="spinner"></span>
        </span>
      }
      <!-- Clear Button -->
      @if (!isLoading && searchCtrl.value) {
        <button
          type="button"
          class="search-clear-btn"
          (mousedown)="$event.preventDefault()"
          (click)="clearSelection()"
          aria-label="Clear">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        </button>
      }
    </div>
    <!-- Custom Dropdown -->
    @if (shouldShowDropdown) {
      <div class="search-dropdown"
        #searchDropdown
        [class.dropdown-fixed]="isInsideTable && dropdownPosition"
        [ngStyle]="isInsideTable && dropdownPosition ? dropdownPosition : {}">
        <!-- Loading State -->
        @if (isLoading) {
          <div class="dropdown-loading">
            <span class="loading-spinner"></span>
            <span class="loading-text">Searching...</span>
          </div>
        }
        <!-- Results List -->
        @if (!isLoading && filteredResult && filteredResult.length > 0) {
          <div class="dropdown-results">
            @for (item of filteredResult; track item; let i = $index) {
              <div
                class="dropdown-item"
                [class.highlighted]="i === highlightedIndex"
                (mouseenter)="highlightedIndex = i"
                (mousedown)="$event.preventDefault()"
                (click)="selectItem(item)">
                <div class="item-content">
                  <div class="item-main">
                    <span class="item-label">{{item[labelKey]}}</span>
                    @if (secondaryLabelKey) {
                      <span class="item-secondary">{{item[secondaryLabelKey]}}</span>
                    }
                  </div>
                  @if (rightLabelKey) {
                    <div class="item-right">
                      @if (rightLabelType == 'text') {
                        <span class="item-value">{{item[rightLabelKey]}}</span>
                      }
                      @if (rightLabelType == 'currency') {
                        <span class="item-value currency">{{item[rightLabelKey] | currency}}</span>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
        <!-- No Results State -->
        @if (!isLoading && hasSearched && (!filteredResult || !filteredResult.length)) {
          <div class="dropdown-no-results">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.3-4.3"></path>
              <path d="M8 11h6"></path>
            </svg>
            <span>No results found</span>
          </div>
        }
      </div>
    }
  </div>
}

<!-- Selected Item Display -->
@if (selectedItem && showSelectionDiv) {
  <div class="selected-item-chip" [style.background-color]="selectedItemBackGroundColor">
    <span class="selected-text" [style.margin-right]="selectedTextMarginRightValue">
      {{this.selectedItem[labelKey] ?? '--'}}
    </span>
    @if (rightLabelKey) {
      <div class="selected-right">
        @if (rightLabelType == 'text') {
          <span class="selected-value">{{selectedItem[rightLabelKey]}}</span>
        }
        @if (rightLabelType == 'currency') {
          <span class="selected-value">{{selectedItem[rightLabelKey] | currency}}</span>
        }
      </div>
    }
    <button type="button" class="selected-remove" (click)="clearSelection()" aria-label="Remove">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
      </svg>
    </button>
  </div>
}
